import { render, staticRenderFns } from "./St31WeekForm.vue?vue&type=template&id=3b6e1587&"
import script from "./St31WeekForm.vue?vue&type=script&lang=js&"
export * from "./St31WeekForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports